import modal from "@/plugins/modal";
import cache from "@/plugins/cache";
import bus from "@/plugins/bus"

export default {
    install(app) {
        app.config.globalProperties.$modal = modal;
        app.config.globalProperties.$cache = cache;
        app.config.globalProperties.$bus = bus;
    }
}